/**
 * Bareeq Tech React App
 * Main application component with React Router integration
 * Uses OmaniEcommerce component with React Router navigation
 */

import React from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

// Import the main OmaniEcommerce component
import OmaniEcommerce from './components/generated/OmaniEcommerce';
import WhatsAppButton from './components/WhatsAppButton';

// Wrapper component to connect OmaniEcommerce with React Router
const OmaniEcommerceRouter: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Map React Router paths to OmaniEcommerce view modes
  const getViewFromPath = (path: string): 'home' | 'services' | 'service-detail' | 'about' | 'team' | 'contact' | 'solutions' | 'industries' => {
    if (path === '/') return 'home';
    if (path === '/services') return 'services';
    if (path.startsWith('/service/')) return 'service-detail';
    if (path === '/about') return 'about';
    if (path === '/team') return 'team';
    if (path === '/contact') return 'contact';
    if (path === '/solutions') return 'solutions';
    if (path === '/industries') return 'industries';
    return 'home';
  };

  // Handle navigation from OmaniEcommerce component
  const handleNavigate = (view: 'home' | 'services' | 'service-detail' | 'about' | 'team' | 'contact' | 'solutions' | 'industries', service?: any) => {
    switch (view) {
      case 'home':
        navigate('/');
        break;
      case 'services':
        navigate('/services');
        break;
      case 'service-detail':
        if (service) {
          navigate(`/service/${service.slug}`, { state: { service } });
        }
        break;
      case 'about':
        navigate('/about');
        break;
      case 'team':
        navigate('/team');
        break;
      case 'contact':
        navigate('/contact');
        break;
      case 'solutions':
        navigate('/solutions');
        break;
      case 'industries':
        navigate('/industries');
        break;
      default:
        navigate('/');
    }
  };

  // Get current view from path
  const currentView = getViewFromPath(location.pathname);
  const service = location.state?.service;

  return (
    <OmaniEcommerce 
      initialView={currentView}
      selectedService={service}
      onNavigate={handleNavigate}
    />
  );
};

// Main App Component
const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/*" element={<OmaniEcommerceRouter />} />
      </Routes>
      <WhatsAppButton />
    </Router>
  );
};

export default App;
